module.exports = __webpack_public_path__ + "img/ic_next.9b24546f.svg";